import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useMemo } from 'react';
export function useInitialValues() {
  const $ = _c(4);
  const router = useRouter();
  const {
    query
  } = router;
  let t0;
  if ($[0] !== query.data) {
    bb0: {
      if (query.data) {
        const dataArray = Array.isArray(query.data) ? query.data : [query.data];
        try {
          t0 = dataArray.reduce(_temp, {});
          break bb0;
        } catch {
          let t1;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {};
            $[2] = t1;
          } else {
            t1 = $[2];
          }
          t0 = t1;
          break bb0;
        }
      }
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      t0 = t1;
    }
    $[0] = query.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(acc, data) {
  const parsedData = JSON.parse(decodeURIComponent(window.atob(data)));
  return {
    ...acc,
    ...parsedData
  };
}